module.exports = __webpack_public_path__ + "media/images/landkit/masks/avatar-group-hover-last-b68e19610a6ccf604b3a572692c0fb26.svg";